import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import {
  CreatePromotionPayload,
  GetPromotionListParams,
  PromotionState,
  UpdatePromotionPayload,
} from "./type";
import { generateQueryString } from "../helper/helpers";

export const getPromotionList = createAsyncThunk(
  "web/promotion-list",
  async (payload: GetPromotionListParams, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/promotions${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_PROMOTIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getPromotionDetail = createAsyncThunk(
  "web/promotion-detail",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/promotions/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_PROMOTION_DETAIL(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const createPromotion = createAsyncThunk(
  "web/create-promotion",
  async (payload: CreatePromotionPayload, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/promotions`, payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const updatePromotion = createAsyncThunk(
  "web/update-promotion",
  async (
    { id, payload }: { id: string; payload: UpdatePromotionPayload },
    thunkAPI,
  ) => {
    try {
      const data = await axios.put(`/admin/promotions/${id}`, payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const publishPromotion = createAsyncThunk(
  "web/publish-promotion",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.patch(`/admin/promotions/${id}/publish`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const pausePromotion = createAsyncThunk(
  "web/pause-promotion",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.patch(`/admin/promotions/${id}/pause`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const deletePromotion = createAsyncThunk(
  "web/delete-promotion",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.delete(`/admin/promotions/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: PromotionState = {
  loading_promotions: false,
  promotions: undefined,
  loading_promotion_detail: false,
  promotion_detail: undefined,
  loading_create_promotion: false,
  loading_promotion_action: false,
  loading_update_promotion: false,
};

export const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    SET_PROMOTIONS: (state, action) => {
      state.promotions = action.payload;
    },
    SET_PROMOTION_DETAIL: (state, action) => {
      state.promotion_detail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromotionList.pending, (state) => {
        state.loading_promotions = true;
      })
      .addCase(getPromotionList.fulfilled, (state) => {
        state.loading_promotions = false;
      })
      .addCase(getPromotionList.rejected, (state) => {
        state.loading_promotions = false;
      })
      .addCase(getPromotionDetail.pending, (state) => {
        state.loading_promotion_detail = true;
      })
      .addCase(getPromotionDetail.fulfilled, (state) => {
        state.loading_promotion_detail = false;
      })
      .addCase(getPromotionDetail.rejected, (state) => {
        state.loading_promotion_detail = false;
      })
      .addCase(createPromotion.pending, (state) => {
        state.loading_create_promotion = true;
      })
      .addCase(createPromotion.fulfilled, (state) => {
        state.loading_create_promotion = false;
      })
      .addCase(createPromotion.rejected, (state) => {
        state.loading_create_promotion = false;
      })
      .addCase(updatePromotion.pending, (state) => {
        state.loading_update_promotion = true;
      })
      .addCase(updatePromotion.fulfilled, (state) => {
        state.loading_update_promotion = false;
      })
      .addCase(updatePromotion.rejected, (state) => {
        state.loading_update_promotion = false;
      })
      .addCase(publishPromotion.pending, (state) => {
        state.loading_promotion_action = true;
      })
      .addCase(publishPromotion.fulfilled, (state) => {
        state.loading_promotion_action = false;
      })
      .addCase(publishPromotion.rejected, (state) => {
        state.loading_promotion_action = false;
      })
      .addCase(pausePromotion.pending, (state) => {
        state.loading_promotion_action = true;
      })
      .addCase(pausePromotion.fulfilled, (state) => {
        state.loading_promotion_action = false;
      })
      .addCase(pausePromotion.rejected, (state) => {
        state.loading_promotion_action = false;
      })
      .addCase(deletePromotion.pending, (state) => {
        state.loading_promotion_action = true;
      })
      .addCase(deletePromotion.fulfilled, (state) => {
        state.loading_promotion_action = false;
      })
      .addCase(deletePromotion.rejected, (state) => {
        state.loading_promotion_action = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const { SET_PROMOTIONS, SET_PROMOTION_DETAIL } = promotionSlice.actions;

export default promotionSlice.reducer;
